import { FieldDataType } from "src/app/modules/core/store/models";
import { DateRuleOffsetType } from "../../workflow-rule-edit/workflow-rule-edit.model";

export interface SetFieldValueRuleConfiguration {
  sourceFieldName?: string;
  sourceFieldValue?: string;
  targetFieldName?: string;
  sourceValueType: SourceValueType;
  dateOffset: number;
  dateOffsetType: DateRuleOffsetType;
  sourceDiffFieldName?: string;
  sourceNumberFieldName?: string;
}

export enum SourceValueType {
  SpecificValue = 1,
  DocumentField = 2,
  Today = 3,
  DateDiff = 4,
}

